/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzGetManagedPermissionsPermissionsOfUserQueryResponse, UsersAuthzGetManagedPermissionsPermissionsOfUserPathParams, UsersAuthzGetManagedPermissionsPermissionsOfUser401, UsersAuthzGetManagedPermissionsPermissionsOfUser403 } from "../models/UsersAuthzGetManagedPermissionsPermissionsOfUser";

export function getUsersAuthzGetManagedPermissionsPermissionsOfUserUrl(userId: UsersAuthzGetManagedPermissionsPermissionsOfUserPathParams["userId"]) {
  const res = { method: 'GET', url: `/users-authz/v1/users/${userId}/permissions` as const }
  return res
}

/**
 * @description Requires CLIENT_ADMIN role or client API key
 * @summary Get all permissions for a specific user
 * {@link /users-authz/v1/users/:userId/permissions}
 */
export async function usersAuthzGetManagedPermissionsPermissionsOfUser(userId: UsersAuthzGetManagedPermissionsPermissionsOfUserPathParams["userId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<UsersAuthzGetManagedPermissionsPermissionsOfUserQueryResponse, ResponseErrorConfig<UsersAuthzGetManagedPermissionsPermissionsOfUser401 | UsersAuthzGetManagedPermissionsPermissionsOfUser403>, unknown>({ method : "GET", url : getUsersAuthzGetManagedPermissionsPermissionsOfUserUrl(userId).url.toString(), ... requestConfig })
  return res.data
}